import html2canvas from 'html2canvas';

export const exportPNG = (
  idCanvas,
  idDownloadLink,
  setDiagramDownload,
  onOfNotif,
  notifText,
  options
) => {
  window.scrollTo(0, 0);
  html2canvas(document.getElementById(idCanvas), options).then(canvas => {
    const downloadLink = document.getElementById(idDownloadLink);
    const imgdata = canvas
      .toDataURL('image/png')
      .replace(/^data:image\/png/, 'data:application/octet-stream');
    downloadLink.setAttribute('href', imgdata);
    downloadLink.click();

    downloadLink.removeAttribute('href');
    setDiagramDownload('');
    onOfNotif('on', notifText, false, '2000');
  });
};
